/* global FormData */
import React from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import { CardTitle } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'

import api from '../../api'
import FileInput from '../file-input'
import { setSnackbarMessage } from '../../actions/snackbar'

const buttonStyle = {
  margin: '1em 1em 0 0'
}

class CreateMedia extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      errors: {},
      resource: {}
    }
  }

  handleNameChange (e, newValue) {
    e.preventDefault()
    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        name: newValue
      }
    }))
  }

  handleFileChange (file) {
    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        file
      }
    }))
  }

  render () {
    return (
      <div>
        <CardTitle title='Create Media' style={{ paddingLeft: 0 }} />
        <form onSubmit={this.handleSubmit.bind(this)}>
          <TextField
            name='name'
            floatingLabelText='Name'
            errorText={this.state.errors.name}
            onChange={this.handleNameChange.bind(this)}
          />

          <div style={{ marginBottom: '1em' }}>
            <FileInput
              label='Upload file'
              onFileSelected={this.handleFileChange.bind(this)}
            />
            {this.state.resource.file && <p>
              Current File: {this.state.resource.file.name}
            </p>}
            {this.state.errors.file &&
              <p style={{ color: 'red' }}>{this.state.errors.file.join(' ')}</p>}
          </div>

          <RaisedButton
            label='Save'
            primary
            onClick={this.handleSubmit.bind(this)}
            style={buttonStyle}
          />

          <RaisedButton
            label='Cancel'
            onClick={this.handleCancel.bind(this)}
            style={buttonStyle}
          />
        </form>
      </div>
    )
  }

  handleSubmit (e) {
    e.preventDefault()

    const formData = new FormData()
    if (this.state.resource.name) {
      formData.append('name', this.state.resource.name)
    }
    if (this.state.resource.file) {
      formData.append('file', this.state.resource.file)
    }

    api.postFile('admin/media', { body: formData })
      .then(res => res.json().then(data => {
        if (!res.ok) {
          this.setState({ errors: data.errors })
          return
        }
        this.props.setSnackbarMessage('Media upload successful')
        if (this.props.onResourceCreated) {
          this.props.onResourceCreated(data)
        }
        if (!this.props.noRedirect) {
          browserHistory.push('/media')
        }
      }))
  }

  handleCancel (e) {
    if (!this.props.noRedirect) {
      e.preventDefault()
      browserHistory.goBack()
    }
    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }
}

export default connect(null, { setSnackbarMessage })(CreateMedia)
